module.exports = __webpack_public_path__ + "img/2chargeStage.12be7ada.jpg";